import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

// Hooks
import useFetchLeave from 'modules/timeoff/hooks/useFetchLeave'

import useRejectLeave from './useRejectLeave'

interface Props {
  leaveId: number
  onClose: () => void
  onRejected?: () => void
  fromShifts?: boolean
}

const RejectLeavePage = ({ leaveId, onClose, onRejected, fromShifts = false }: Props) => {
  const { leave } = useFetchLeave({
    leaveId,
    onClose,
  })

  const { form, onSubmit } = useRejectLeave({
    leave,
    onClose,
    onRejected,
    fromShifts,
  })

  const initialReason = form.get('reason').value || leave.attributes.reason || ''
  const [reason, setReason] = React.useState(initialReason)
  const [showInfo, setShowInfo] = React.useState(false)

  const MAX_LENGTH = 200

  const handleReasonChange = (value: string) => {
    setReason(value)
    if (value.length === MAX_LENGTH) setShowInfo(true)
    if (value.length !== MAX_LENGTH) setShowInfo(false)

    form.setValues({ reason: value })
  }

  return (
    <Modal
      title={i18n.t('time_off.reject_title')}
      description={i18n.t('time_off.reject_description')}
      illustration="calendar"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <Button type="negative" submit>
          {i18n.t('common.reject')}
        </Button>
      }
    >
      <TextArea
        label={i18n.t('time_off.reason')}
        value={reason}
        onChange={handleReasonChange}
        maxLength={MAX_LENGTH}
        info={i18n.t('settings.leave_types.page.basic_information.form.caption.info')}
        showInfo={showInfo}
        showCharacterCount
      />
    </Modal>
  )
}

export default RejectLeavePage
